import Dropdown from "components/CoDropdown";
import { CoDropdownItemProps } from "components/CoDropdown/CoDropdown";
import useLabels from "hooks/useLabels";
import { useAppSelector } from "hooks/useStore";

type HistoryActionsButtonProps = {
  onDelete: () => void;
  onSave: () => void;
  isSelected?: boolean;
};

// Vertical ellipsis button that expands into more options next to each history item in the sidebar.
function HistoryActionsButton({ onDelete, onSave }: HistoryActionsButtonProps) {
  const [searchHistoryLabels] = useLabels("screens.sidebar.history");
  const isMobile = useAppSelector((state) => state.setting.isMobile);

  const menuItems: CoDropdownItemProps[] = [
    {
      key: "save",
      title: searchHistoryLabels["save-to-list"],
      onClick: onSave,
      leftIcon: <i className="text-xl icon-bookmark" />,
      dataTestId: "save-to-list",
    },
    {
      key: "delete",
      title: searchHistoryLabels["delete"],
      onClick: onDelete,
      danger: true,
      leftIcon: <i className="text-xl icon-trash-2" />,
      dataTestId: "delete-button",
    },
  ];

  return (
    <Dropdown items={menuItems} showArrow placement="right">
      <button
        className={
          "h-8 w-8 block rounded-xl hover:bg-bg-subtle group-hover:block mobile:hidden"
        }
      >
        <i
          className="icon-ellipsis-vertical text-fg-muted"
          data-testid="ellipsis-button"
        />
      </button>
    </Dropdown>
  );
}

export default HistoryActionsButton;
